const generalFeatureFlags = {};

const featureFlagsComponents = {
  CONSUMER_BASIC_AUTH: 'components_consumer_basic_auth',
  COMPONENTS_EXPERIMENTAL_PALLETE_ENABLED_FRONT:
    'components_experimental_pallete_enabled_front',
  COMPONENTS_EXECUTION_TRACE_ANNOTATIONS_ENABLED_FRONT:
    'components_execution_trace_annotations_enabled_front'
};

const featureFlagDesignSystem = {
  SETTINGS_GLOBALS_V2: 'settings_globals_v2',
  SETTINGS_ACCOUNTS_V2: 'settings_accounts_v2',
  GSS_CUSTOM_LAYOUT: 'gss_custom_layout'
};

const featureFlagsGovernance = {
  GOVERNANCE_REDIRECT_CONSUMPTION_TO_TOGAI:
    'governance-redirect-consumption-to-togai',
  GOVERNANCE_AI_POLICY_TAB: 'governance-ai-policy-tab',
  GOVERNANCE_CONSUMPTION_PAGE_EVOLUTION:
    'governance-consumption-page-evolution',
  GOVERNANCE_NEW_LICENSE_PAGE: 'governance-new-license-page',
  GOVERNANCE_NEW_CONSUMPTION_PAGE: 'governance-new-consumption-page',
  GOVERNANCE_PROJECT_2_0_ASSOCIATION: 'governance-project-2-0-association',
  GOVERNANCE_SIMPLIFIED_CONSUMPTION_MODEL:
    'governance-simplified-consumption-model'
};

const featureFlagsDesignTime = {
  DESIGN_TIME_PIPELINE_DIFF: 'design_time_pipeline_diff',
  DESIGN_TIME_CAPSULE_DIFF: 'design_time_capsule_diff',
  DESIGN_TIME_PIPELINES_CAPSULES_RELATIONSHIPS:
    'design_time_pipelines_capsules_relationships',
  DESIGN_TIME_REST_CONNECTOR_CURL: 'design_time_rest_connector_curl',
  DESIGN_TIME_REST_CONNECTOR_OPENAPI: 'design_time_rest_connector_openapi',
  DESIGN_TIME_CONSUMPTION_ALERTS: 'designtime-consumption-alerts'
};

const featureFlagsRun = {
  RUN_SET_ENGINE_VERSION: 'run_set_engine_version',
  RUN_DISABLE_ITAU_AUTOSCALING: 'run_disable_itau_autoscaling',
  RUN_BETA_ENGINE_V3: 'run_beta_engine_v3'
};

const featureFlagsMonitor = {
  MONITOR_SETDEFAULTENVIRONMENT_FRONT: 'monitor_setdefaultenvironment_front',
  MONITOR_CHART_SUCCESS_AND_ERRORS: 'monitor_chart_success_and_errors',
  MONITOR_CHART_TOTAL_LATENCY: 'monitor_chart_total_latency',
  MONITOR_CHART_CURRENTLY_RUNNING: 'monitor_chart_currently_running',
  MONITOR_CHART_INVOCATIONS_EXECUTIONS_ERRORS:
    'monitor_chart_invocations_executions_errors',
  MONITOR_CHART_QUEUE_INFLIGHT: 'monitor_chart_queue_inflight',
  MONITOR_CHART_MEMORY_MESSAGE: 'monitor_chart_memory_message',
  MONITOR_CHART_TOTAL_PIPELINE_RESPONSE_TIME:
    'monitor_chart_total_pipeline_response_time',
  MONITOR_CHART_TOTAL_RUNNING_REPLICAS: 'monitor_chart_total_running_replicas',
  MONITOR_INSIGHTS_CONCURRENT_FETCH: 'monitor_insights_concurrent_fetch',
  MONITOR_CHART_TOP_OFFENDERS_CONNECTOR:
    'monitor-chart-top-offenders-connector',
  MONITOR_CHART_TOP_OFFENDERS_CONNECTOR_SELECT:
    'monitor-chart-top-offenders-connector-select',
  MONITOR_ASSIST: 'monitor_assist',
  MONITOR_OPEN_PIPELINE: 'monitor_open_pipeline',
  MONITOR_CHART_REQUEST_QUEUE_TIME: 'monitor_chart_request_queue_time',
  MONITOR_TOP_OFFENDERS_OBJECT_STORE_CONNECTOR:
    'monitor_top_offenders_object_store_connector',
  MONITOR_TOP_OFFENDERS_PIPELINE_EXECUTOR_CONNECTOR:
    'monitor_top_offenders_pipeline_executor_connector',
  MONITOR_TOP_OFFENDERS_SCRIPT_CONNECTOR:
    'monitor_top_offenders_script_connector',
  MONITOR_TOP_OFFENDERS_SCRIPT_V2_CONNECTOR:
    'monitor_top_offenders_script_v2_connector',
  MONITOR_TOP_OFFENDERS_SOAP_CONNECTOR_V2:
    'monitor_top_offenders_soap_connector_v2',
  MONITOR_TOP_OFFENDERS_SOAP_CONNECTOR_V3:
    'monitor_top_offenders_soap_connector_v3',
  MONITOR_MIGRATE_PIPELINE_LOGS_TO_MONITOR_SERVICE:
    'monitor_migrate_pipeline_logs_to_monitor_service',
  MONITOR_MIGRATE_EXECUTIONS_TO_MONITOR_SERVICE:
    'monitor_migrate_executions_to_monitor_service',
  MONITOR_MIGRATE_LOGS_EXPORT_TO_MONITOR_SERVICE:
    'monitor_migrate_logs_export_to_monitor_service',
  MONITOR_MIGRATE_MESSAGES_TO_MONITOR_SERVICE:
    'monitor_migrate_messages_to_monitor_service',
  MONITOR_MIGRATE_OVERVIEW_TO_MONITOR_SERVICE:
    'monitor_migrate_overview_to_monitor_service',
  MONITOR_PIPELINE_LOGS_AUTOCOMPLETE_FILTERS:
    'monitor_pipeline_logs_autocomplete_filters',
  MONITOR_EXECUTIONS_AUTOCOMPLETE_FILTERS:
    'monitor_executions_autocomplete_filters',
  MONITOR_OVERVIEW_AUTOCOMPLETE_FILTERS:
    'monitor_overview_autocomplete_filters',
  MONITOR_AGENT_LOGS: 'monitor_agent_logs',
  MONITOR_AGENT_LOGS_COLLECT_TEST_CASE: 'monitor_agent_logs_collect_test_case'
};

const featureFlagsBuild = {
  BUILD_LINT_ITEM: 'build_lint_item',
  BUILD_SCAFFOLD_RESPONSES: 'build_scaffold_responses',
  BUILD_SHOW_DIGIFORM: 'build_show_digiform',
  BUILD_DISCOVERY_SELECTOR: 'build_discovery_selector',
  BUILD_HELP_HUB_V2: 'build_help_hub_v2',
  BUILD_NEW_AI_ASSISTANT_CHAT: 'build_new_ai_assistant_chat',
  BUILD_AI_NATIVE_CHAT: 'build_ai_native_chat',
  BUILD_NEW_AI_ASSISTANT_CHAT_PIPELINE: 'build_new_ai_assistant_chat_pipeline',
  BUILD_NEW_AI_ASSISTANT_CHAT_JOLT: 'build_new_ai_assistant_chat_jolt',
  BUILD_NEW_AI_ASSISTANT_CHAT_DOC: 'build_new_ai_assistant_chat_doc',
  BUILD_NEW_AI_ASSISTANT_CHAT_QNA: 'build_new_ai_assistant_chat_qna',
  BUILD_ENABLE_DOUBLE_BRACES_ALIAS: 'build_enable_double_braces_alias',
  BUILD_ENABLE_STEP_INTELLISENSE: 'build_enable_step_intellisense',
  BUILD_ENABLE_TRIGGER_INTELLISENSE: 'build_enable_trigger_intellisense',
  BUILD_ENABLE_DOUBLE_BRACES_ALIAS_LINTER:
    'build_enable_double_braces_alias_linter',
  BUILD_ENABLE_CAPSULES_DOUBLE_BRACES_ALIAS:
    'build_enable_capsules_double_braces_alias',
  BUILD_FAST_PASTE_FLOWSPEC: 'build_fast_paste_flowspec',
  BUILD_TEST_CASE_V3: 'build_test_case_v3',
  BUILD_TEST_CASE_USE_BACKEND_VALIDATION:
    'build_test_case_use_backend_validation',
  BUILD_MESSAGES_TAB: 'build_messages_tab',
  BUILD_SHOW_TOOL_SCOPES: 'build_show_tool_scopes',
  BUILD_PIPELINES_SIDEBAR_HEROUI: 'build_pipelines_sidebar_heroui',
  BUILD_ENABLE_ITERATORS_SCOPE: 'build_enable_iterators_scope',
  BUILD_GLOBALS: 'build_globals',
  BUILD_GLOBALS_CRON_CATEGORY: 'build_globals_cron_category',
  BUILD_ACCOUNTS: 'build_accounts',
  BUILD_JSON_GENERATOR_MOCK: 'build_json_generator_mock',
  BUILD_CONFIGURE_API_MODAL: 'build_configure_api_modal',
  BUILD_CANVAS_USE_DIRECT_ICON_URL: 'build_canvas_use_direct_icon_url',
  BUILD_CANVAS_LAZY_LOAD_CONNECTORS: 'build_canvas_lazy_load_connectors',
  BUILD_ENABLE_CRON_EXPRESSION_INTELLISENSE:
    'build_enable_cron_expression_intellisense'
};

const featureFlagsAI = {
  AI_CAPSULE_DOCUMENTATION: 'ai_capsule_documentation',
  AI_CHAT_ASSISTANT: 'ai_chat_assistant',
  AI_NEW_PIPEGEN_MODEL: 'ai_new_pipegen_model'
};

const featureFlagsCapsules = {
  CAPSULE_API_V2: 'capsule_api_v2',
  CAPSULE_IGNORE_OUTSPEC_SCHEMA:
    'capsules_validateOutSpecSchema_ignoreValidation',
  CAPSULE_API_V2_GROUPS: 'capsule_api_v2_groups',
  CAPSULES_CANVAS_SAVE_FORM_NAME_FIELD: 'capsules_canvas_save_form_name_field',
  CAPSULE_SAVE_SETTINGS_ALERT: 'capsule_save_settings_alert'
};

const featureFlagsConnectivity = {
  CONNECTIVITY_ZTNA_MVP_ENABLED_FRONT: 'connectivity_ztna_mvp_enabled_front',
  CONNECTIVITY_ZTNA_MVP_DELETE_CONNECTION_ENABLED_FRONT:
    'connectivity_ztna_mvp_delete_connection_enabled_front',
  CONNECTIVITY_ZTNA_MVP_CREATE_ROUTE_ENABLED_FRONT:
    'connectivity_ztna_mvp_create_route_enabled_front',
  CONNECTIVITY_ZTNA_MVP_EDIT_ROUTE_ENABLED_FRONT:
    'connectivity_ztna_mvp_edit_route_enabled_front',
  CONNECTIVITY_ZTNA_MVP_DELETE_ROUTE_ENABLED_FRONT:
    'connectivity_ztna_mvp_delete_route_enabled_front',
  CONNECTIVITY_ZTNA_MVP_CREATE_ROUTE_BTACH_ENABLED_FRONT:
    'connectivity_ztna_batch_creation_enabled_front'
};

const featureFlagConstants = {
  ...generalFeatureFlags,
  ...featureFlagsBuild,
  ...featureFlagsAI,
  ...featureFlagsRun,
  ...featureFlagsMonitor,
  ...featureFlagDesignSystem,
  ...featureFlagsComponents,
  ...featureFlagsGovernance,
  ...featureFlagsCapsules,
  ...featureFlagsConnectivity,
  ...featureFlagsDesignTime
};

export default featureFlagConstants;
